module.exports = __webpack_public_path__ + "static/media/Vector.dfc6018f.svg";